import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core'
import PhoneDeviceImage from './PhoneDevice.png'
import { theme } from 'get-theme'

const mapStateToProps = state => ({
    smallView: state.smallView
})

const mapDispatchToProps = dispatch => ({
})

const styles = theme => ({
    addPhonesContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.primary.text,
        textAlign: 'center'
    },
    deviceImage: {
        height: 250,
        width: 250,
    },
    lineOne: {
        fontWeight: 500,
        fontSize: 24,
        lineHeight: '34px',
        marginBottom: 5
    },
    lineTwo: {
        fontWeight: 500,
        fontSize: 18,
        lineHeight: '26px',
        marginBottom: 20,
        '& span': {
            color: theme.palette.primary.main
        }
    },
    lineThree: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '22px'
    }
})

class AddPhonesLarge extends Component {
    constructor (props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount () {
        console.log('init add-phones')
    }
    render () {
        const { classes } = this.props

        return (
            <div className={classes.addPhonesContainer}>
                <img className={classes.deviceImage} src={PhoneDeviceImage}/>
                <div className={classes.lineOne}>Need a phone?</div>
                <div className={classes.lineTwo}>Give us a call at <span>(877) 746-6310</span>, Option 1</div>
                <div className={classes.lineThree}>Our sales team can help you purchase a phone that fits your needs.</div>
            </div>
        )
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(AddPhonesLarge))
